import { iconBaseProps, type FillableIconProps } from "@/components/ui/icons/icon-base"

const rects = (
  <>
    <rect x="3" y="3" width="7" height="7" />
    <rect x="14" y="3" width="7" height="7" />
    <rect x="3" y="14" width="7" height="7" />
    <rect x="14" y="14" width="7" height="7" />
  </>
)

export const GridIcon = ({ size = 22, filled = false, ...props }: FillableIconProps) =>
  filled ? (
    <svg {...iconBaseProps(size, props)} fill="currentColor">
      {rects}
    </svg>
  ) : (
    <svg {...iconBaseProps(size, props)} fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      {rects}
    </svg>
  )
